import type { ExportTranslationDTO } from '../service/ai-translation.repository.interface';
import type { ExportTranslationRequest } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ExportTranslation } from '@/infrastructure/api-functions/interface/export-translation.interface';

@injectable()
export class ExportTranslationDTOImpl implements ExportTranslationDTO {
    constructor(
        @inject(ExportTranslation)
        private readonly _exportTranslationApi: ExportTranslation,
    ) { }

    async fetch(value: ExportTranslationRequest): Promise<string> {
        const params = {
            original: value.original,
            title: value.title,
            translation: value.translation,
        };
        return await this._exportTranslationApi.exportTranslation(params);
    }
}
